var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "akar-icons:edit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.2083 5.18348L18.2371 7.21227M17.5126 3.39619L12.0242 8.88456C11.7406 9.16775 11.5472 9.52854 11.4684 9.92148L10.9614 12.4591L13.4991 11.9512C13.892 11.8726 14.2523 11.68 14.536 11.3964L20.0244 5.90798C20.1893 5.74305 20.3201 5.54725 20.4094 5.33177C20.4987 5.11628 20.5446 4.88532 20.5446 4.65208C20.5446 4.41884 20.4987 4.18788 20.4094 3.9724C20.3201 3.75691 20.1893 3.56111 20.0244 3.39619C19.8595 3.23126 19.6637 3.10043 19.4482 3.01117C19.2327 2.92192 19.0017 2.87598 18.7685 2.87598C18.5352 2.87598 18.3043 2.92192 18.0888 3.01117C17.8733 3.10043 17.6775 3.23126 17.5126 3.39619Z",
    stroke: "#757575",
    strokeWidth: 1.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.6282 14.3763V17.2513C18.6282 17.7596 18.4262 18.2471 18.0668 18.6066C17.7073 18.966 17.2198 19.168 16.7115 19.168H6.16984C5.66151 19.168 5.174 18.966 4.81455 18.6066C4.45511 18.2471 4.25317 17.7596 4.25317 17.2513V6.70964C4.25317 6.2013 4.45511 5.71379 4.81455 5.35435C5.174 4.9949 5.66151 4.79297 6.16984 4.79297H9.04484",
    stroke: "#757575",
    strokeWidth: 1.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.796adf85925eeb4f8eb8c02305167459.svg";
export { ForwardRef as ReactComponent };